import { render, staticRenderFns } from "./ModalAddDisbursement.vue?vue&type=template&id=658e52c6"
import script from "./ModalAddDisbursement.vue?vue&type=script&lang=js"
export * from "./ModalAddDisbursement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports